<template>
  <div class="stacked-content__container">
    <div class="stacked-content__container-inner">
      <wHeader
        class="stacked-content__content-container"
        :heading="heading"
        :isPageHeading="isPageHeading"
        :subheading="subheading"
        :copy="copy"
        :readTime="readTime"
        :tags="tags"
        :secondaryHeadingStyle="secondaryStyle"
      >
        <div
          class="stacked-content__content-container"
          v-if="stackedContent && stackedContent.length"
        >
          <div
            class="stacked-content__item"
            :class="{ 'stacked-content__item--secondary': secondaryStyle }"
            v-for="(item, i) in stackedContent"
            :key="item.heading + i"
          >
            <div class="stacked-content__item-content">
              <h2
                v-if="item.heading && isPageHeading"
                class="stacked-content__item-heading"
              >
                {{ item.heading }}
              </h2>
              <h3
                v-if="item.heading && !isPageHeading"
                class="stacked-content__item-heading"
              >
                {{ item.heading }}
              </h3>
              <div
                class="stacked-content__item-copy"
                :class="{
                  'stacked-content__item-copy--secondary': secondaryStyle
                }"
                v-html="item.content"
              />
            </div>
            <div
              class="stacked-content__item-image-container"
              :class="{
                'stacked-content__item-image-container--secondary': secondaryStyle
              }"
            >
              <wImage :src="item.image" :alt="item.imageAlt" :placeholder="item.placeholder" />
            </div>
          </div>
        </div>
        <slot />
      </wHeader>
      <div
        class="stacked-content__image-container"
        :class="{
          'stacked-content__image-container--page-heading': isPageHeading
        }"
      >
        <wImage :src="image" :alt="alt" class="stacked-content__image" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
    wHeader: () => import('@/components/web/wHeader.vue'),
    wImage: () => import('@/components/web/wImage.vue'),
  },
  name: "w-stacked-content-banner",
  props: {
    secondaryStyle: {
      type: Boolean,
      default: false
    },
    isPageHeading: {
      type: Boolean,
      default: false
    },
    heading: String,
    subheading: String,
    copy: String,
    icons: Array,
    image: String,
    alt: String,
    readTime: String,
    tags: Array,
    stackedContent: Array
  }
};
</script>

<style lang="scss" scoped>

.stacked-content {
  &__container {
    position: relative;
    z-index: 1;
    margin: 0;
    padding: $spacing-md;
    background: #F0F9FE;
    @include tablet-portrait {
      margin: $spacing-xl 0;
    }
    @include tablet-landscape {
      padding: $spacing-md $spacing-xl;
    }
  }
  &__container-inner {
    @include tablet-landscape {
      display: flex;
      align-items: center;
      max-width: 1380px;
      margin: 0 auto;
    }
  }
  &__content-container {
    margin: $spacing-md 0 0;
    @include tablet-landscape {
      flex: 1 1 60%;
    }
  }
  &__image-container {
    text-align: center;
    margin: 0;
    @include tablet-landscape {
      display: flex;
      align-items: center;
      flex: 1 1 40%;
      max-height: 320px;
    }
    &--page-heading {
      @include tablet-landscape {
        align-items: flex-start;
      }
    }
  }
  &__image {
    width: 100%;
    max-width: 420px;
    @include tablet-landscape {
      width: auto;
      max-width: 130%;
      max-height: 480px;
    }
  }

  &__item {
    margin: 35px 0;
    @include tablet-portrait {
      display: flex;
      flex-wrap: wrap;
    }
    &--secondary {
      @include tablet-portrait {
        flex-direction: row-reverse;
        align-items: center;
      }
    }
    &:after {
      content: "";
      display: block;
      width: 100%;
      height: 2px;
      background-image: url(../../assets/images/grey-dots-horizontal.png);
      background-repeat: repeat-x;
      background-size: 6px 2px;
      margin: 35px auto 0;
    }
    &:last-of-type {
      &:after {
        content: none;
      }
    }
  }

  &__item-heading {
    color: $secondary;
    font-size: pxToRem(21);
    line-height: 1.2;
    margin: 0 0 20px;
    @include tablet-portrait {
      font-size: pxToRem(26);
    }
  }

  &__item-content {
    flex: 1 1 0;
  }

  &__item-copy {
    &--secondary {
      color: $primary;
      font-weight: bold;
    }
  }

  &__item-copy::v-deep {
    p {
      &:first-child {
        margin-top: 0;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__item-image-container {
    text-align: center;
    line-height: 0;
    max-width: 200px;
    margin: $spacing-sm auto 0;
    @include tablet-portrait {
      margin: 0 0 0 $spacing-md;
    }
    &--secondary {
      @include tablet-portrait {
        margin: 0 $spacing-md 0 0;
      }
    }
    img {
      max-width: 100%;
    }
  }
}
</style>
